import {sendAFEvent, setAFCustomerId} from './appsflyer';
import {sendAmplitudeData, setAmplitudeUserId, sendAmplitudeRevenue} from './amplitude';
import { sendLockerStudioData } from './lockerStudio';
import BI_EVENTS from './biEvents';
import {PLANS} from './eCommerce';


const isStage = process.env.REACT_APP_ENV === 'stage';

export const sendAnalyticsEvents = (eventName, eventParams = {}) => {
    const biEventName = BI_EVENTS[eventName];

    sendAFEvent(eventName, eventParams);
    sendAmplitudeData(eventName, eventParams);
    sendLockerStudioData(biEventName || eventName, eventParams);
    pushGoogleTag(eventName, eventParams);
};

export const sendRevenueEvent = plan => {
    let eventParams = PLANS[plan];
    sendAmplitudeRevenue(eventParams);
};

export const setAnalyticsUserId = (userId = '') => {
    setAmplitudeUserId(userId);
    setAFCustomerId(userId);
};

export const pushGoogleTag = (eventName, eventParams) => {
    if (isStage) return;
    window.gtag?.('event', eventName, eventParams);
};

export const pushFBEvent = (data, eventId) => {
    if (window.fbq) {
        window.fbq('track', 'Purchase'+(isStage ? '_test' : ''), data, {eventID: eventId});
    }
};
